
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import ConfirmModal from '../../ConfirmModal/index.vue'
import { ConfirmModalOptions } from '@xt/client/entities/kindred-spirit/kindred-spirit'
import { dataSource_all_cities } from '@xt/client/dataSource/kindred-spirit/index'

@Component({
  components: {
    ConfirmModal
  }
})
export default class CityFilterModal extends Vue {
  options: ConfirmModalOptions = {
    layoutClassName: 'city-filter-confirm-modal',
    confirmText: '确认',
    cancelText: '重置',
    confirmedHide: true
  }
  loading: boolean = false
  provinceList: Array<{
    label: string
    adcode: string
  }> = []
  select: string = ''

  @Ref()
  confirmModal: {
    show: (options: ConfirmModalOptions) => Promise<boolean>
    hide: () => void
  }

  get GuildStore() {
    return this.$store.$tonghao.Guild
  }

  async show() {
    const res = await this.confirmModal.show(this.options)

    if (res) {
      this.$emit('on-select', this.select)
    } else {
      this.select = ''
      this.$emit('on-reset')
    }
  }

  hide() {
    this.confirmModal.hide()
  }

  handleSelect(select: string) {
    if (this.select === select) return

    this.select = select
  }

  created(): void {
    this.provinceList = [
      {
        label: '全部省份',
        adcode: ''
      }
    ].concat(
      dataSource_all_cities.map(item => ({
        label: item.parent.name,
        adcode: item.parent.adcode
      }))
    )
  }

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
